<template>
    <section class="mt-7 mb-16 sushi-elem">
        <article class="wrapper">
            <h2 class="text-orange">Formulário de contacto</h2>
            <div class="contact-container dots bg-white rounded-lg w-full mt-4 relative">
                <form @submit="(event) => sendRequest(event)">
                    <div class="flex mt-2">
                        <img src="/svg/ic_form_orange.svg" alt="form" class="inline-block mr-1 object-contain">
                        <h4 class="mt-1">preenche o formulário</h4>
                    </div>
                    <p class="text-danger error hidden">{{ apiError }}</p>
                    <p v-if="apiSuccess" class="text-success error">{{ apiSuccess }}</p>
                    <div v-else>
                        <div class="lg:flex">
                            <div class="input-container w-full lg:pr-4 mt-4 input-error">
                                <label>Nome*</label>
                                <div class="input-box">
                                    <div class="icon name-icon"></div>
                                    <input v-model="name" type="text" wire:model.lazy="name" class="form-control"
                                        placeholder="O teu nome">
                                </div>
                                <span v-if="fieldsWithError.name" class="text-danger error">{{ fieldsWithError.name
                                    }}</span>
                            </div>
                            <div class="input-container w-full mt-4 input-error">
                                <label>posição*</label>
                                <div class="select-container">
                                    <multiselect2 :options="availableJobs" :is-searchable="true"
                                        :api-search-enabled="true" v-model="type" name="jobApplication"
                                        optional-name="onCartSavedAddressZipCodeChange">
                                    </multiselect2>
                                </div>
                            </div>
                        </div>

                        <div class="lg:flex">
                            <div class="input-container w-full mt-4 lg:pr-4 input-error">
                                <label>Email*</label>
                                <div class="input-box">
                                    <div class="icon email-icon"></div>
                                    <input v-model="email" type="text" wire:model.lazy="email" class="form-control"
                                        placeholder="Email">
                                </div>
                                <span v-if="fieldsWithError.email" class="text-danger error">{{ fieldsWithError.email
                                    }}</span>
                            </div>
                            <div class="input-container w-full mt-4 input-error">
                                <label>contacto telefónico*:</label>
                                <VuePhoneNumberInput class="phone-input" v-model="phone" :no-validator-state="true"
                                    default-country-code="PT" @update="(payload) => updatePhoneCode(payload)"
                                    :translations="{ phoneNumberLabel: 'Telefone' }" />
                                <span v-if="fieldsWithError.phonecode || fieldsWithError.phone"
                                    class="text-danger error">{{ fieldsWithError.phone ? fieldsWithError.phone :
                                    fieldsWithError.phonecode }}</span>
                            </div>
                        </div>

                        <div class="input-container w-full mt-4">
                            <label>Mensagem*</label>
                            <div class="input-box">
                                <div class="icon email-icon"></div>
                                <textarea v-model="message_content" name="message" id="contact-us-field" cols="30"
                                    rows="10" placeholder="Escreve aqui a tua mensagem"></textarea>
                            </div>
                            <span v-if="fieldsWithError.message_content" class="text-danger error">{{
                                fieldsWithError.message_content }}</span>
                        </div>
                        <div class="cv-input-wrapper" :data-text="cvLabel">
                            <input name="cv-input-field" type="file" class="cv-input-field" accept="application/pdf"
                                @change="updateCV">
                        </div>
                        <span class="text-danger error">{{ fieldsWithError.cv }}</span>
                        <div class="flex flex-col-reverse lg:flex-row lg:justify-between mt-4">
                            <button type="submit" class="btn-bg">Enviar</button>
                            <p class="text-info mt-4">*campos obrigatórios</p>
                        </div>

                    </div>
                </form>
            </div>
        </article>
    </section>
</template>

<script>
import multiSelect2 from './../multiselect2';
import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';

export default {
    props: {
        availableJobs: {required: false}
    },
    components: {
        multiSelect2,
        VuePhoneNumberInput
    },
    data: () => ({
        name: '',
        email: '',
        phone: '',
        phoneCode: '', //prefix
        message_content: '',
        type: '',
        cv: '',
        cvLabel: 'Upload CV',
        apiError: '',
        apiSuccess: false,
        fieldsWithError: []
    }),
    methods: {
        sendRequest(e){
            e.preventDefault()

            this.fieldsWithError = []
            this.apiError = ''

            let payload = new FormData()
            payload.append('name', this.name)
            payload.append('email', this.email)
            payload.append('phone', this.phone)
            if(this.phoneCode == 'undefined'){
                this.phoneCode == null
            }
            payload.append('phonecode', this.phoneCode)
            payload.append('message_content', this.message_content)
            payload.append('type', this.type.type)
            payload.append('cv', this.cv)

            console.log(payload)
            this.$axios({
                method: 'post',
                url: '/api/work-with-us',
                data: payload,
                config: { headers: {'Content-Type': 'multipart/form-data' }}
            })
            .then(response => {
                if(response.data.message){
                    this.apiSuccess = response.data.message

                    this.fieldsWithError = [];
                    this.name = null;
                    this.email = null;
                    this.phone = null;
                    this.phoneCode = null;
                    this.message_content = null;
                    this.type = null;
                    this.cv = null;
                }
                console.log(response)
            })
            .catch(error => {
                this.apiError = error.response.data.message

                if(error.response.data.errors){
                    for(const [key, value] of Object.entries(error.response.data.errors)){
                        this.fieldsWithError[key] = value[0]
                        console.log(key, value)
                    }
                }
            });
        },
        updateCV (event) {
            const files = event.target.files
            this.cvLabel = files[0].name
            this.cv = files[0]
        },
        updatePhoneCode (payload) {
            this.phoneCode = payload.countryCallingCode
        }
    },
}
</script>
